import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-about-me-contact-information",
	templateUrl: "./about-me-contact-information.component.html",
	styleUrls: ["../../../customer.scss"],
})
export class AboutMeContactInformationComponent implements OnInit {
	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {}

	onRemovePhone(val: string) {
		console.log("click");
		this.app.confirmation.confirm({
			message: `Remove ${this.app.references.phoneNumberToDisplayFormat(val)} from your account?`,
			accept: async () => {
				//TODO - add phone remove
				console.log("remove");
				this.app.msgSvc.add({
					severity: AppMessageSeverity.BLUE,
					summary: "",
					detail: `Removed ${this.app.references.phoneNumberToDisplayFormat(val)} from your account.`,
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
